import React from 'react';
import './serviceheader.css';
import serviceContent from '../../../content/pages/service.json';

const ServiceHeader = () => {
    return (
        <div className='service-header-container'>
            <img src={serviceContent.header.image} alt="Service Header" className="service-header-image" />
        </div>
    );
};

export default ServiceHeader;
